export function DemoPage() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-2">Demo Page</h1>
      <p className="text-muted-foreground mb-8">This is a demo page created to test the MyJarvis MCP push flow.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="rounded-xl border bg-card p-5">
          <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">Metric A</p>
          <p className="text-2xl font-semibold">42</p>
        </div>
        <div className="rounded-xl border bg-card p-5">
          <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">Metric B</p>
          <p className="text-2xl font-semibold">87%</p>
        </div>
        <div className="rounded-xl border bg-card p-5">
          <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">Metric C</p>
          <p className="text-2xl font-semibold">$1,200</p>
        </div>
      </div>

      <div className="rounded-xl border bg-card p-6 mb-6">
        <h2 className="text-lg font-semibold mb-3">About This Page</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          This demo page was generated automatically by the Jarvis dashboard assistant.
          It demonstrates the full push → build → ship flow: files were written to a
          preview branch, the build passed, and the branch was merged to main — all
          without touching git or the terminal.
        </p>
      </div>

      <div className="rounded-xl border bg-card p-6">
        <h2 className="text-lg font-semibold mb-3">What's Next?</h2>
        <ul className="text-sm text-muted-foreground space-y-2">
          <li>• Replace this content with real data from your database</li>
          <li>• Wire up <code className="bg-muted px-1 rounded">/api/[resource]</code> endpoints for live queries</li>
          <li>• Add charts, tables, or any other components you need</li>
        </ul>
      </div>
    </div>
  );
}
